import React from 'react'
import sample from "../assets/sampleimage.png";

const Cancelrefund = () => {
  return (
    <div>

    
      <div className="mb-4">
        <img
          src={sample}
          alt="Refund & Cancellation Banner"
          className="img-fluid w-100"
        />
      </div>

     
      <div className="container mb-4">
        <h2 className="text-center mb-4">Refund & Cancellation Policy</h2>

        <div className="card shadow-sm p-4">

          <p className="mb-4">
            At our boutique, we aim to provide a smooth and satisfying shopping  
            experience. This Refund & Cancellation Policy outlines the situations  
            in which returns, refunds, or cancellations may be accepted, as per  
            our store guidelines and applicable Indian consumer laws. We request  
            all customers to review this policy before placing an order.
          </p>

          <p className="mb-4">
            Refunds or returns are only accepted if the delivered product is  
            damaged, defective, incorrect, or does not match the description or  
            images shown on our website. To qualify for a return, the item must  
            be unused, unwashed, and returned in its original packaging along  
            with the invoice or shipping label. Customers must raise a return or  
            refund request within <strong>3 days</strong> of delivery. Items  
            purchased during sales or special offers are strictly non-returnable  
            and non-refundable.
          </p>

          <p className="mb-4">
            To initiate a refund or replacement, customers should contact our  
            support team within <strong>2 days</strong> of receiving the order  
            and provide the order ID, images of the product, and a short  
            explanation. Once approved, replacements will be delivered within   
             <strong>  5–7 days</strong>. If a refund is approved after inspection,  
            the amount will be credited to the original payment method within  
            <strong>3–4 business days</strong>. Shipping charges, if any, are  
            non-refundable under all circumstances.
          </p>

          <p className="mb-4">
            Orders cannot be cancelled once they enter processing or dispatch  
            stages. If a cancellation request is made before processing begins,  
            the amount will be refunded as per our payment gateway timelines.  
            Any delays caused by banks or payment providers are beyond our  
            control, though we will assist you in tracking the refund status.
          </p>

          <p>
            By using our website and placing orders, you acknowledge and agree  
            to abide by this Refund & Cancellation Policy. For any assistance,  
            customers may contact our support team through the details provided  
            on our website. We reserve the right to update or modify this policy  
            at any time, and customers are advised to review it periodically.
          </p>

        </div>
      </div>
    </div>
  );
};

export default Cancelrefund;
